import { AlertKindStatuse, Area } from '@/models/WeatherWarning'

// R08気象警報注意報API（app2）の kind
// 通常の気象警報注意報に加えて、指定河川洪水予報由来の情報を含む場合がある
export type AlertKind2Attrs = {
  name: string
  code: string
  status: AlertKindStatuse
  rawName?: string
  source?: string
  happyouAt?: string
  level?: number
  riverName?: string
}

// 指定河川洪水予報由来の河川情報
export type RiverAttrs = {
  name: string
  code: string
  kindName: string
  kindCode: string
  condition: string
  headline: string
  updatedAt: string
}

export type WeatherWarning2Attrs = {
  areaCode: string
  area: Area
  publishingOffice: string
  headline: string
  updatedAt: string
  kinds: AlertKind2Attrs[]
  rivers?: RiverAttrs[]
}

export class AlertKind2 {
  public name: string
  public code: string
  public status: AlertKindStatuse
  public rawName?: string
  public source?: string
  public happyouAt?: string
  public level?: number
  public riverName?: string

  constructor(attrs: AlertKind2Attrs) {
    this.name = attrs.name
    this.code = attrs.code
    this.status = attrs.status
    this.rawName = attrs.rawName
    this.source = attrs.source
    this.happyouAt = attrs.happyouAt
    this.level = attrs.level
    this.riverName = attrs.riverName
  }
}

export class River {
  public name: string
  public code: string
  public kindName: string
  public kindCode: string
  public condition: string
  public headline: string
  public updatedAt: string

  constructor(attrs: RiverAttrs) {
    this.name = attrs.name
    this.code = attrs.code
    this.kindName = attrs.kindName
    this.kindCode = attrs.kindCode
    this.condition = attrs.condition
    this.headline = attrs.headline
    this.updatedAt = attrs.updatedAt
  }
}

export default class WeatherWarning2 {
  public areaCode: string
  public area: Area
  public publishingOffice: string
  public headline: string
  public updatedAt: string
  public kinds: AlertKind2[]
  public rivers: River[]

  constructor(attrs: WeatherWarning2Attrs) {
    this.areaCode = attrs.areaCode
    this.area = attrs.area
    this.publishingOffice = attrs.publishingOffice
    this.headline = attrs.headline
    this.updatedAt = attrs.updatedAt
    this.kinds = (attrs.kinds ?? []).map(kind => new AlertKind2(kind))
    this.rivers = (attrs.rivers ?? []).map(river => new River(river))
  }

  public findKind(code: string) {
    return this.kinds.find(kind => kind.code === code)
  }
}
